<div class="container-fluid" *ngIf="_empService.formHideShow==0">
    <!-- <div class="row flex-body">
        <div class="col-md-11 col-md-offset-1">
            <div class="box">
                <h4 class="box-title">Employee</h4>
            </div>

            <div class="col-md-4 offset-md-8 searchBox">
                <div class="form-group row no-gutters">
                    <div class="col-12 col-sm-6 col-md-2">
                        <button type="button" class="btn-sm btn-info" (click)="addList()"><i class="fas fa-plus"
                                aria-hidden="true"></i></button>
                    </div>
                    <div class="col-12 col-sm-6 col-md-8"><input type="text" class="form-control-search" name="search"
                            [(ngModel)]="term"></div>
                    <div class="col-6 col-md-2">
                        <button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button>
                    </div>
                </div>
            </div> -->

    <br>
    <div id="form-wrap">
        <h2 class="heading_all">EMPLOYEE</h2>
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4"></div>
            <div class="col-md-4 ">

                <table>
                    <thead>
                        <tr>
                            <td>
                                <button type="button" class="btn-sm btn-info" (click)="addList()"><i class="fas fa-plus"
                                        aria-hidden="true"></i></button>
                            </td>
                            <td style="width:60%;"><input type="text" class="form-control-search" name="search"
                                    [(ngModel)]="term"></td>
                            <td><button class="btn-info"><i class="fas fa-search" aria-hidden="true"></i></button></td>
                        </tr>
                    </thead>
                </table>

            </div>
        </div>

        <table>
            <thead>
                <tr>
                    <th>#</th>
                    <!-- <th (click)="sort('code')"> EmpId</th>
                        <th (click)="sort('name')">Name</th>
                        <th>Action</th> -->
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('EmpId')">
                            <span *ngIf="!_empService.isFiltering">EmpId</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_empService.orderByColName!='EmpId' "></i>
                                <div *ngIf="_empService.orderByColName=='EmpId'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_empService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_empService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_empService.isFiltering">
                            <input type="text" #txtEmpIdSFilter="ngModel" [(ngModel)]="_empService.EmpIdFilter"
                                placeholder="EmpId">
                        </div>

                    </th>
                    <th class="hidden-xs">
                        <div class="AtjIsPoint" (click)="sort('EmpName')">
                            <span *ngIf="!_empService.isFiltering">Name</span>
                            <div class="AtjfloatRight">
                                <i class="fas fa-sort" *ngIf="_empService.orderByColName!='EmpName' "></i>
                                <div *ngIf="_empService.orderByColName=='EmpName'">
                                    <i class="fas fa-sort-amount-down" *ngIf="_empService.orderByDir"></i>
                                    <i class="fas fa-sort-amount-up-alt" *ngIf="!_empService.orderByDir"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="_empService.isFiltering">
                            <input type="text" #txtEmpNameSFilter="ngModel" [(ngModel)]="_empService.EmpNameFilter"
                                placeholder="Name">
                        </div>

                    </th>
                    <th><em></em> Settings
                        <a class="AtjIsPoint AtjfloatRight" (click)="toggleFilter()">
                            <i *ngIf="!_empService.isFiltering" class="fas fa-filter"></i>
                            <i *ngIf="_empService.isFiltering" class="fas fa-times"></i>
                        </a>
                    </th>

                </tr>
            </thead>
            <tbody>
                <!-- ngRepeat: item in items -->
                <!-- <tr *ngFor="let emp of _empService.allEmployees | orderBy: key : reverse | filter:term | paginate: { itemsPerPage: NoOfItems, currentPage: p }; let i = index"
                        class="ng-scope"> -->
                <tr *ngFor="let emp of _empService.allEmployees | gridOperations  :_empService.pageIndex: 
                        {EmpId:_empService.EmpIdFilter,EmpName:_empService.EmpNameFilter}:
                       {Column:_empService.orderByColName,Dir:_empService.orderByDir} ; let i = index"
                    class="ng-scope">
                    <td>{{i+1+((NoOfItems*_empService.pageIndex)-NoOfItems)}}</td>
                    <td>{{emp.EmpId}}</td>
                    <td>{{emp.EmpName}}</td>
                    <td>
                        <button type="button" class="btn-success" (click)="showForEdit(emp)">
                            <i class="fas fa-pen-square" aria-hidden="true"></i></button>

                        <button type="button" class="btn-danger" (click)="onDelete(emp)"><i class="fas fa-trash"
                                aria-hidden="true"></i></button>
                    </td>
                </tr><!-- end ngRepeat: item in items -->
                <tr>
                    <td colspan="4"
                        *ngIf="(_empService.allEmployees?.length<=0 )  || _CommonService.filterdItemCount<1">
                        No Records To
                        Display.</td>
                </tr>
            </tbody>
            <tfoot>
                <td colspan="4" *ngIf="_CommonService.totalPageCount>1">
                    <app-grid-pagination (pageIndexValue)="_empService.pageIndex=$event">
                    </app-grid-pagination>
                </td>
            </tfoot>
        </table>
        <!-- <pagination-controls (pageChange)="p = $event"></pagination-controls> -->
    </div>
    <div class="margintop"></div>
    <!-- </div>
    </div> -->
</div>
<app-delete-confirm *ngIf="deletePopUp" [title]="'EMPLOYEE'" (ConfirmEvent)="dialogResult($event)"></app-delete-confirm>
<div style="margin-top: 120px;"></div>